<template>
  <div class="bg-login">
    <form @submit.prevent="onLogin">
      <div
        style="height: 100vh; width: 100vw; max-width: 100%"
        class="flex justify-content-center align-items-center"
      >
        <div class="grid w-full">
          <div class="lg:col-4 lg:col-offset-4 md:col-8 md:col-offset-2 col-12">
            <Card>
              <template #title=""> เข้าสู่ระบบ POD Admin </template>
              <template #content="">
                <div class="formgrid grid">
                  <div class="col-12 field">
                    <label for="username">Username</label>
                    <InputText
                      id="username"
                      v-model="username"
                      class="inputfield w-full text-xl"
                    ></InputText>
                    <small v-if="v$.username.$error" class="p-error">{{
                      v$.username.$errors[0].$message
                    }}</small>
                  </div>

                  <div class="col-12 field">
                    <label for="password">Password</label>
                    <Password
                      id="password"
                      v-model="password"
                      class="w-full"
                      inputClass="inputfield w-full text-xl"
                      :toggleMask="true"
                    ></Password>
                    <small v-if="v$.password.$error" class="p-error">{{
                      v$.password.$errors[0].$message
                    }}</small>
                  </div>

                  <div class="col-8 p-fluid">
                    <Button
                      icon="pi pi-check"
                      label="เข้าสู่ระบบ"
                      class="p-button-success"
                      type="submit"
                    ></Button>
                  </div>
                  <div class="col-4 p-fluid">
                    <Button
                      icon="pi pi-times"
                      label="ยกเลิก"
                      class="p-button-danger"
                      @click="onCancel"
                    ></Button>
                  </div>
                  <div class="col-12 my-2 flex justify-content-end">
                    <Image
                      src="https://www.haadthip.com/assets/images/logo.svg"
                      image-style="height:2rem"
                    >
                    </Image>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { usePlugin } from "@/plugins";
import useVuelidate from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";
import { LoginDto, UserDto } from "@/types";

export default defineComponent({
  setup() {
    const {
      success,
      warning,
      error,
      information,
      confirm,
      store,
      router,
      axios,
      setLoading,
    } = usePlugin();
    const username = ref("");
    const password = ref("");

    const rules = {
      username: { required, minLength: minLength(4) },
      password: { required },
    };

    const v$ = useVuelidate(rules, { username, password });

    const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
    const onLogin = async () => {
      v$.value.$reset();
      v$.value.$touch();
      if (v$.value.$invalid) return;

      setLoading(true);
      try {
        const result = await axios.post<UserDto>(`api/v1/authen`, {
          username: username.value,
          password: password.value,
        } as LoginDto);
        store.value.token = result.data.token;
        store.value.username = result.data.username;
        store.value.name = result.data.name;
        store.value.salesOfficeAuthority = result.data.salesOfficeAuthority;
        store.value.reportAuthority = result.data.reportAuthority;
        store.value.adminAuthority = result.data.adminAuthority;
        axios.defaults.headers = {
          Authorization: `Bearer ${store.value.token}`,
          Accept: "application/json, text/plain, */*",
        };
        router.replace({ name: "Home" });
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onCancel = () => {
      username.value = "";
      password.value = "";
      v$.value.$reset();
    };
    return {
      username,
      password,
      onLogin,
      onCancel,
      v$,
    };
  },
});
</script>

<style scoped>
.bg-login {
  background-image: url("../assets/login.jpg");
  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
